import RoutesMap from "route_control/RouteControl"
import { PremiseList, PremiseDeepDive, AddPremise, UpdatePremise, ManagePremise, PremiseHierarchy, AssignUnit, UnitDetails, UpdateOwner, UpdateTenant, VacateUnit, GateList, AddGate, UpdateGate, ParkingList, VehicleList, RuleList, AddRule, UpdateRule, RuleDetails, VendorList, AddVendor, UpdateVendor, Property, PremisesAndLogs } from "pages/premises"

const PremisesRoute = () => {
    return [
        {
            path: RoutesMap.PREMISE_LIST.path,
            element: <PremiseList />
        },
        {
            path: RoutesMap.PREMISE_DEEP_DIVE.path,
            element: <PremiseDeepDive />
        },
        {
            path: RoutesMap.ADD_PREMISE.path,
            element: <AddPremise />
        },
        {
            path: RoutesMap.UPDATE_PREMISE.path,
            element: <UpdatePremise />
        },

        {
            path: RoutesMap.PREMISE_MANAGE.path,
            element: <ManagePremise />
        },
        {
            path: RoutesMap.PREMISE_HIERARCHY.path,
            element: <PremiseHierarchy />
        },
        {
            path: RoutesMap.ASSIGN_UNIT.path,
            element: <AssignUnit />
        },
        {
            path: RoutesMap.UNIT_DETAILS.path,
            element: <UnitDetails />
        },
        {
            path: RoutesMap.UPDATE_OWNER.path,
            element: <UpdateOwner />
        },
        {
            path: RoutesMap.UPDATE_TENANT.path,
            element: <UpdateTenant />
        },
        {
            path: RoutesMap.VACATE_UNIT.path,
            element: <VacateUnit />
        },
        {
            path: RoutesMap.GATE_LIST.path,
            element: <GateList />
        },
        {
            path: RoutesMap.ADD_GATE.path,
            element: <AddGate />
        },
        {
            path: RoutesMap.UPDATE_GATE.path,
            element: <UpdateGate />
        },
        {
            path: RoutesMap.PARKING_LIST.path,
            element: <ParkingList />
        },
        {
            path: RoutesMap.VEHICLE_LIST.path,
            element: <VehicleList />
        },
        {
            path: RoutesMap.RULE_LIST.path,
            element: <RuleList />
        },
        {
            path: RoutesMap.ADD_RULE.path,
            element: <AddRule />
        },
        {
            path: RoutesMap.UPDATE_RULE.path,
            element: <UpdateRule />
        },
        {
            path: RoutesMap.RULE_DETAILS.path,
            element: <RuleDetails />
        },
        {
            path: RoutesMap.VENDOR_LIST.path,
            element: <VendorList />
        },
        {
            path: RoutesMap.ADD_VENDOR.path,
            element: <AddVendor />
        },
        {
            path: RoutesMap.UPDATE_VENDOR.path,
            element: <UpdateVendor />
        },
        {
            path: RoutesMap.PROPERTY.path,
            element: <Property />
        },
        {
            path: RoutesMap.PREMISES_AND_LOGS.path,
            element: <PremisesAndLogs />
        },
    ]
}

export default PremisesRoute;